module.exports = __webpack_public_path__ + "static/product-l0950-red-b31a4ba4539b53239b98713d38c0da2b.png";